import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setAlert } from '../../../actions/alert';
import { limpiarCategoriaEmpresaConfiguracion, obtenerCategoriaEmpresaConfiguracion, editarCategoriaEmpresaConfiguracion } from '../../../actions/configuracion';

const EditarCategoria = ({ categoria, reestablecerCategoria }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.categorias_empresas);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [categoriaData, setCategoriaData] = useState({
        id: null,
        nombre: null
    });

    /* Editar categoria */
    const handleInputChange = ({ target }) => {
        setCategoriaData({
            ...categoriaData,
            [target.name]: target.value
        });
    }
    
    const handleProcesar = async () => {
        if(categoriaData.nombre){
            await setStatusProcesar(true);
            await dispatch(editarCategoriaEmpresaConfiguracion(categoriaData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setCategoriaData({
                id: null,
                nombre: null
            });
            setEditarModal(false);
            reestablecerCategoria(null);
        }
    }

    useEffect(() => {
        dispatch(limpiarCategoriaEmpresaConfiguracion());
    }, []);

    useEffect(() => {
        if(categoria){
            setEditarModal(true);
            
            dispatch(obtenerCategoriaEmpresaConfiguracion(categoria?._id));

            setCategoriaData({
                ...categoriaData,
                id: categoria?._id
            });
        }
    }, [categoria]);

    useEffect(() => {
        if(detalles){
            setCategoriaData({
                ...categoriaData,
                id: detalles?._id, 
                nombre: detalles?.nombre
            });
        }
    }, [detalles]);

    return (
        <Modal show={editarModal} backdrop="static" size="md" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar categoria</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={categoriaData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarCategoria;